import ReportOverview from 'components/containers/ReportOverview';
import LoginLogoutLayout from 'layouts/LoginLogout';
import withTilstandsrapport from 'lib/withTilstandsrapport';
import { NextPage } from 'next';
import React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'store';
import { getAddress } from 'store/tilstandsrapportEntities/tilstandsrapport/selectors';

interface Props {
  tilstandsrapportId: string;
}

interface StateProps {
  address: string;
}

const PageOverview: NextPage<Props> = ({ address, tilstandsrapportId }: Props & StateProps) => {
  return (
    <LoginLogoutLayout showBoxShadow={true}>
      <ReportOverview tilstandsrapportId={tilstandsrapportId} />
    </LoginLogoutLayout>
  );
};

const mapStateToProps = (state: AppState, ownProps): StateProps => ({
  address: getAddress(state, ownProps.tilstandsrapportId),
});

export default withTilstandsrapport(connect<StateProps, {}, Props>(mapStateToProps, null)(PageOverview));
